import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPlus } from "react-icons/fa";

const extractOptions = ["IMITMF", "IMINVF", "SAHDRF", "SALINF"];

const EditStores = () => {
  const location = useLocation();

  const [locationMap, setLocationMap] = useState({});
  const [formData, setFormData] = useState({
    parentno: "",
    storename: "",
    storestatus: "",
    corporatestorenbr: "",
    access_token: "",
    api_key: "",
    api_secretkey: "",
    shopify_websiteurl: "",
    shopify_adminurl: "",
    utc: "",
    utc_dates: "",
    extract_name: "",
    enable_extract: "",
  });
  const [extracts, setExtracts] = useState([]);
  const [matchedStores, setMatchedStores] = useState([]);
  const [showExtractDropdown, setShowExtractDropdown] = useState(false);
  // const { corporatestorenbr } = useParams();
  const navigate = useNavigate();

  const [corporatestorenbr, setCorporatestorenbr] = useState(null);
  const [ParentNo, setParentNo] = useState(null);

  useEffect(() => {
    const { corporatestorenbr } = location.state || {};
  
    if (!corporatestorenbr) {
      navigate("/liststores");
    } else {
      setCorporatestorenbr(corporatestorenbr); 
    }
  }, []);
  

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) setShowExtractDropdown(false);
    };
  
    document.addEventListener("click", handleClickOutside);
  
    API.storeSetting("edit")
      .then((res) => {
        if (res && res.data) {
          const matchedStores = res.data.filter(
            (store) => store.corporatestorenbr === corporatestorenbr
          );
          setMatchedStores(matchedStores);
  
          const primaryStore = matchedStores[0];
  
          if (primaryStore) {
            const storeLocation =
              (primaryStore.storecity || "") +
              (primaryStore.storecity && primaryStore.storestate ? ", " : "") +
              (primaryStore.storestate || "");
  
            const locations = matchedStores
              .map((store) => ({
                location_id: store.location_id?.split(",") || [],
                location_name: store.location_name?.split(",") || [],
                location_corporatestorenbr: store.location_corporatestorenbr,
              }))
              .flatMap((store) =>
                store.location_id.map((id, index) => ({
                  location_id: id.trim(),
                  location_name: store.location_name[index]?.trim() || "",
                  location_corporatestorenbr: store.location_corporatestorenbr || "",
                }))
              )
              .filter(
                (value, index, self) =>
                  index ===
                  self.findIndex(
                    (t) =>
                      t.location_id === value.location_id &&
                      t.location_name === value.location_name
                  )
              );
  
            const locationMap = locations.reduce((acc, loc) => {
              const corp = primaryStore.corporatestorenbr;
              if (!acc[corp]) {
                acc[corp] = [];
              }
              acc[corp].push({
                location_corporatestorenbr: loc.location_corporatestorenbr,
                location_id: loc.location_id,
                location_name: loc.location_name,
                original_id: loc.location_id, // store original for backend reference
              });
              return acc;
            }, {});
  
            setLocationMap(locationMap);
            console.log("locationMap:", locationMap);
          

            setFormData({
              parentno: primaryStore.parentno || "",
              storename: primaryStore.storename || "",
              storestatus: primaryStore.storestatus || "",
              storecity: storeLocation,
              corporatestorenbr: primaryStore.corporatestorenbr || "",
              access_token: primaryStore.access_token || "",
              api_key: primaryStore.api_key || "",
              api_secretkey: primaryStore.api_secretkey || "",
              shopify_websiteurl: primaryStore.shopify_websiteurl || "",
              shopify_adminurl: primaryStore.shopify_adminurl || "",
              utc: primaryStore.utc || "",
              utc_dates: primaryStore.utc_dates || "",
              extract_name: "",
              enable_extract: "",
            });
  
            const enabledExtracts = matchedStores
              .filter((store) => store.enable_extract?.toLowerCase() === "1")
              .map((store) => store.extract_name)
              .flatMap((name) => name?.split(",").map((e) => e.trim()) || []);
  
            setExtracts([...new Set(enabledExtracts)]);
          }
        }
      })
      .catch(async (err) => {
        const text = await err?.response?.text?.();
        console.error("Raw error response:", text);
        toast.error("Error fetching store data", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
      });
  
    return () => document.removeEventListener("click", handleClickOutside);
  }, [corporatestorenbr]);
  
  const handleGroupedLocationChange = (corpNo, index, field, value) => {
  const updated = { ...locationMap };
  const existing = updated[corpNo][index];
  updated[corpNo][index] = {
    ...existing,
    [field]: value,
    original_id: existing.original_id, // retain for update match
  };
  setLocationMap(updated);
};

  const handleAddGroupedRow = (corpNo) => {
    const updated = { ...locationMap };
    updated[corpNo].push({
      location_id: "",
      location_name: "",
      // original_id: "", // empty for new entries
    });
    setLocationMap(updated);
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define required fields
  const requiredFields = [
    "access_token",
    "api_key",
    "api_secretkey",
    "shopify_websiteurl",
    "shopify_adminurl",
    "utc",
    "utc_dates",
  ];

  // Check for empty required fields
  const emptyFields = requiredFields.filter(
    (field) => !formData[field] || formData[field].trim() === ""
  );

  if (emptyFields.length > 0) {
    toast.error(`Please fill all required fields: ${emptyFields.join(", ")}`, {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      className: "login-toast",
    });
    
    return;
  }
  
    const extract_name_list = extractOptions.join("\n");
    const enable_extract_list = extractOptions.map((opt) =>
      extracts.includes(opt) ? "1" : "0"
    );
  
    const payload = {
      ...formData,
      location: locationMap,
      extract_name: extract_name_list,
      enable_extract: enable_extract_list.join("\n"),
      type: "edit-update",
    };
  
    console.log("locationMap:", locationMap);
    console.log("payload:", payload);
  
    try {
      const response = await API.storeSetting("edit-update", payload);
      if (response?.error === false) {
        sessionStorage.setItem("successMessage", "Store updated successfully!");
        navigate("/liststores");
      } else {
        toast.error("Failed to update store", {
                                position: "top-center",
                                autoClose: false,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                theme: "colored",
                                className: "login-toast",
                              });
      }
    } catch {
      toast.error("Something went wrong while updating the store", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "login-toast",
      });
    }
  };
  

  
  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  return (
    <div className="container-fluid page-body-wrapper">
      <div className="main-panel">
        <div className="content-wrapper" style={{ paddingBottom: "80px" }}>
          <ToastContainer position="top-center" autoClose={500} hideProgressBar={false} />
          <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="form-header">Edit Store</h2>
              <Link to="/liststores" className="btn btn-success btn-sm">
                <i className="mdi mdi-arrow-left"></i>List page
              </Link>
            </div>
            <form onSubmit={handleSubmit}>
            {(() => {
    const fields = [
      "corporatestorenbr", "parentno", "storename", "storestatus",
      "storecity", "access_token", "api_key", "api_secretkey",
      "shopify_websiteurl", "shopify_adminurl"
    ];

    const rows = [];
    for (let i = 0; i < fields.length; i += 2) {
      rows.push(
        <div className="form-row" key={i}>
          {[fields[i], fields[i + 1]].map((name) => name && (
            <div className="form-group col-md-6" key={name}>
              <label>
                {name.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
                {["access_token", "api_key", "api_secretkey", "shopify_websiteurl", "shopify_adminurl", "utc", "utc_dates"].includes(name) && (
                  <span className="requireds">*</span>
                )}
              </label>
              <input
                type="text"
                className="form-control"
                name={name}
                value={formData[name]}
                onChange={handleChange}
                disabled={["corporatestorenbr", "parentno", "storename", "storestatus", "storecity"].includes(name)}
              />
            </div>
          ))}
        </div>
      );
    }

    // Add UTC field separately as full-width
    rows.push(
      <div className="form-row">
        <div className="form-group col-md-6" key="utc">
        <label>UTC Hour<span className="requireds">*</span></label>
        <input
          type="text"
          className="form-control"
          name="utc"
          value={formData["utc"]}
          onChange={handleChange}
        />
      </div>
      <div className="form-group col-md-6" key="utc_dates">
        <label>UTC Dates<span className="requireds">*</span></label>
        <input
          type="text"
          className="form-control"
          name="utc_dates"
          value={formData["utc_dates"]}
          onChange={handleChange}
        />
      </div>
      </div>
    );

    return rows;
  })()}

<div className="form-group">
  {Object.entries(locationMap).map(([corpNo, locations]) => (
    <div key={corpNo} className="mb-3">
      {(locations.length === 0 ? [{}] : locations).map((loc, index) => (
        <div key={index} className="mb-3">
          <div className="form-row align-items-center mb-2" style={{ gap: "10px" }}>
            {locations.length > 1 && (
              <div className="col">
                {index === 0 && (
                  <label htmlFor="location_corporatestorenbr" style={labelStyles}>
                    Corporate Store #<span className="requireds">*</span>
                  </label>
                )}
                <input
                  type="text"
                  placeholder="Corporate Store for new location"
                  className="form-control"
                  value={loc.location_corporatestorenbr || ""}
                  onChange={(e) =>
                    handleGroupedLocationChange(corpNo, index, "location_corporatestorenbr", e.target.value)
                  }
                  
                />
              </div>
            )}

            <div className="col">
              {index === 0 && (
                <label htmlFor="location_id" style={labelStyles}>
                  Location Id<span className="requireds">*</span>
                </label>
              )}
              <input
                type="text"
                placeholder="Location ID"
                className="form-control"
                value={loc.location_id || ""}
                onChange={(e) =>
                  handleGroupedLocationChange(corpNo, index, "location_id", e.target.value)
                }
              />
            </div>

            <div className="col">
              {index === 0 && (
                <label htmlFor="location_name" style={labelStyles}>
                  Location Name<span className="requireds">*</span>
                </label>
              )}
              <input
                type="text"
                placeholder="Location Name"
                className="form-control"
                value={loc.location_name || ""}
                onChange={(e) =>
                  handleGroupedLocationChange(corpNo, index, "location_name", e.target.value)
                }
              />
            </div>
          </div>

          {index === locations.length - 1 && (
            <div className="form-row">
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btn-success btn-block"
                  style={{ minWidth: "150px" }}
                  onClick={() => handleAddGroupedRow(corpNo)}
                >
                  <FaPlus /> New Location
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  ))}
</div>


              {/* Extracts Dropdown */}
              <div className="form-group" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
              <label style={{ marginBottom: "8px" }}>
                Extracts:<span className="requireds">*</span>
              </label>

              <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setShowExtractDropdown(!showExtractDropdown)}
                  style={{
                    width: "100%",
                    color: "#000000",
                    textAlign: "left",
                    padding: "10px 40px 10px 12px",
                    border: "1px solid #ced4da",
                    position: "relative",
                  }}
                >
                  {extracts.length > 0 ? extracts.join(", ") : "Select Extracts"}
                  <span
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  >
                    ▼
                  </span>
                </button>

                {showExtractDropdown && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      padding: "10px",
                      zIndex: 999,
                      border: "1px solid #ced4da",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      columnGap: "20px",
                      rowGap: "10px",
                      background: "#fff",
                    }}
                  >
                    <div style={{ gridColumn: "1 / -1", marginBottom: "5px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                        <input
                          type="checkbox"
                          checked={extracts.length === extractOptions.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setExtracts(extractOptions);
                            } else {
                              setExtracts([]);
                            }
                          }}
                          style={{ width: "16px", height: "16px" }}
                        />
                        <strong>Select All</strong>
                      </label>
                    </div>

                    {extractOptions.map((extractItem) => (
                      <label
                        key={extractItem}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          margin: 0,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          value={extractItem}
                          checked={extracts.includes(extractItem)}
                          onChange={(e) =>
                            setExtracts((prev) =>
                              e.target.checked
                                ? [...new Set([...prev, extractItem])]
                                : prev.filter((val) => val !== extractItem)
                            )
                          }
                          style={{ width: "16px", height: "16px" }}
                        />
                        <span>{extractItem}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
              </div>
              <br />

              <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <button type="submit" className="submit-btn btn btn-success" style={{ padding: "10px 20px" }}>
                  Update Store
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStores;
